export default __webpack_public_path__ + "static/media/SWT1930.34I-41180_-24474_0.f3ef8cfa.jpg";